export const STORE_KEY = '@@customisation'
export const LOAD_THEME_REQUEST = `${STORE_KEY}/LOAD_THEME_REQUEST`
export const LOAD_THEME_SUCCESS = `${STORE_KEY}/LOAD_THEME_SUCCESS`
export const LOAD_THEME_FAILURE = `${STORE_KEY}/LOAD_THEME_FAILURE`
export const LOAD_PREVIEW_THEME_REQUEST = `${STORE_KEY}/LOAD_PREVIEW_THEME_REQUEST`
export const LOAD_PREVIEW_THEME_SUCCESS = `${STORE_KEY}/LOAD_PREVIEW_THEME_SUCCESS`
export const LOAD_PREVIEW_THEME_FAILURE = `${STORE_KEY}/LOAD_PREVIEW_THEME_FAILURE`
export const UPDATE_CUSTOMISATION_SETTING = `${STORE_KEY}/UPDATE_CUSTOMISATION_SETTING`
export const SET_PREVIEW_MODE = `${STORE_KEY}/SET_PREVIEW_MODE`
